import { getFormattedCosts, formatDefaultDate, getLagLabel } from '@/utils'

export const columns = [
  {
    title: '№',
    key: 'number',
    width: 60,
    align: 'center',
    fixed: 'left'
  },
  {
    title: 'Наименование этапа',
    key: 'name',
    width: 300,
    align: 'center',
    fixed: 'left'
  },
  {
    title: 'Срок по договору',
    align: 'center',
    key: 'end_date',
    width: 120,
    fixed: 'left',
    render: (h, params) => {
      return h('span', formatDefaultDate(params.row.end_date))
    }
  },
  {
    title: 'Сумма по договору',
    align: 'center',
    key: 'costs',
    width: 120,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.costs, true))
    }
  },
  {
    title: 'Сумма по договору (с учетом аванса и ГУ)',
    align: 'center',
    key: 'costs_without_payouts',
    width: 160,
    render: (h, params) => {
      return h('span', getFormattedCosts(params.row.costs_without_payouts, true))
    }
  },
  {
    title: 'Блок выпуска ТО',
    align: 'center',
    className: 'reports',
    children: [
      {
        title: 'План. срок выпуска ТО',
        key: 'plan_to_reporting_date',
        align: 'center',
        width: 120,
        className: 'reports',
        render: (h, params) => {
          return h('span', params.row.is_retention ? '' : formatDefaultDate(params.row.plan_to_reporting_date))
        }
      },
      {
        title: 'Факт. срок выпуска ТО',
        align: 'center',
        slot: 'fact_to_reporting_date',
        width: 120,
        className: 'reports'
      },
      {
        title: 'План. срок согл-ия ТО',
        align: 'center',
        key: 'plan_to_finalizing_date',
        width: 120,
        className: 'reports',
        render: (h, params) => {
          return h('span', params.row.is_retention ? '' : formatDefaultDate(params.row.plan_to_finalizing_date))
        }
      },
      {
        title: 'Факт. срок согл-ия ТО',
        align: 'center',
        slot: 'fact_to_finalizing_date',
        width: 120,
        className: 'reports'
      },
      {
        title: 'Отклонение сроков',
        align: 'center',
        key: 'finalizing_lag',
        width: 120,
        className: 'reports',
        render: (h, params) => {
          return h('span', getLagLabel(params.row.finalizing_lag))
        }
      }
    ]
  },
  {
    title: 'Блок подписания актов',
    align: 'center',
    className: 'acts',
    children: [
      {
        title: 'План. срок подписания',
        align: 'center',
        key: 'plan_act_sign_date',
        width: 120,
        className: 'acts',
        render: (h, params) => {
          return h('span', params.row.is_retention ? '' : formatDefaultDate(params.row.plan_act_sign_date))
        }
      },
      {
        title: 'Факт. срок подписания',
        align: 'center',
        slot: 'fact_act_sign_date',
        width: 120,
        className: 'acts'
      },
      {
        title: 'Отклонение сроков',
        align: 'center',
        key: 'act_sign_date_lag',
        width: 120,
        className: 'acts',
        render: (h, params) => {
          return h('span', getLagLabel(params.row.act_sign_date_lag))
        }
      }
    ]
  },
  {
    title: 'Блок получения платежей',
    align: 'center',
    className: 'payments',
    children: [
      {
        title: 'План. срок получения',
        align: 'center',
        key: 'plan_payment_date',
        className: 'payments',
        width: 120,
        render: (h, params) => {
          return h('span', formatDefaultDate(params.row.plan_payment_date))
        }
      },
      {
        title: 'Факт. срок получения',
        align: 'center',
        slot: 'fact_payment_date',
        className: 'payments',
        width: 120
      },
      {
        title: 'Отклонение сроков',
        align: 'center',
        key: 'payment_date_lag',
        className: 'payments',
        width: 120,
        render: (h, params) => {
          return h('span', getLagLabel(params.row.payment_date_lag))
        }
      }
    ]
  },
  {
    title: 'Примечание',
    align: 'center',
    slot: 'description',
    width: 300
  }
]
